<template>
  <ContentWrap>
    <el-form
      ref="queryFormRef"
      :inline="true"
      :model="queryParams"
      class="-mb-15px"
      label-width="80px"
    >
      <el-form-item label="昵称" prop="nickname">
        <el-input
          v-model="queryParams.nickname"
          class="!w-160px"
          clearable
          placeholder="会员昵称"
          @keyup.enter="handleQuery"
        />
      </el-form-item>
      <el-form-item label="手机号" prop="mobile">
        <el-input
          v-model="queryParams.mobile"
          class="!w-160px"
          clearable
          placeholder="手机号"
          @keyup.enter="handleQuery"
        />
      </el-form-item>
      <el-form-item label="订单号" prop="orderNo">
        <el-input
          v-model="queryParams.orderNo"
          class="!w-180px"
          clearable
          placeholder="商城订单号"
          @keyup.enter="handleQuery"
        />
      </el-form-item>
      <el-form-item label="计划编号" prop="planId">
        <el-input
          v-model="queryParams.planId"
          class="!w-140px"
          clearable
          placeholder="计划 ID"
          @keyup.enter="handleQuery"
        />
      </el-form-item>
      <el-form-item label="发放日" prop="grantDate">
        <el-date-picker
          v-model="queryParams.grantDate"
          class="!w-240px"
          end-placeholder="结束"
          start-placeholder="开始"
          type="daterange"
          value-format="YYYY-MM-DD"
        />
      </el-form-item>
      <el-form-item>
        <el-button @click="handleQuery"><Icon class="mr-5px" icon="ep:search" />搜索</el-button>
        <el-button @click="resetQuery"><Icon class="mr-5px" icon="ep:refresh" />重置</el-button>
      </el-form-item>
    </el-form>
  </ContentWrap>

  <ContentWrap>
    <el-table v-loading="loading" :data="list" :stripe="true" :show-overflow-tooltip="true">
      <el-table-column align="center" label="编号" prop="id" width="70" />
      <el-table-column
        align="center"
        label="发放日"
        prop="grantDate"
        width="120"
      />
      <el-table-column align="center" label="会员" min-width="140">
        <template #default="{ row }">
          <div>{{ row.nickname || '-' }}</div>
          <div class="text-xs text-gray-400">{{ row.mobile || row.userId }}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="商品" prop="spuName" min-width="120" />
      <el-table-column align="center" label="订单号" prop="orderNo" min-width="150" />
      <el-table-column align="center" label="金额" width="100">
        <template #default="{ row }">￥{{ fenToYuan(row.price || 0) }}</template>
      </el-table-column>
      <el-table-column align="center" label="计划 ID" prop="planId" width="90" />
      <el-table-column align="center" label="钱包流水" prop="walletTransactionId" min-width="110" />
      <el-table-column
        align="center"
        label="时间"
        prop="createTime"
        :formatter="dateFormatter"
        width="170"
      />
    </el-table>
    <Pagination
      v-model:limit="queryParams.pageSize"
      v-model:page="queryParams.pageNo"
      :total="total"
      @pagination="getList"
    />
  </ContentWrap>
</template>

<script lang="ts" setup>
import { fenToYuan } from '@/utils'
import { dateFormatter } from '@/utils/formatTime'
import * as CashbackGrantApi from '@/api/mall/trade/cashback/grant'
import type { CashbackGrantVO } from '@/api/mall/trade/cashback/grant'

defineOptions({ name: 'TradeCashbackGrant' })

const loading = ref(false)
const list = ref<CashbackGrantVO[]>([])
const total = ref(0)
const queryFormRef = ref()
const queryParams = reactive({
  pageNo: 1,
  pageSize: 10,
  nickname: undefined as string | undefined,
  mobile: undefined as string | undefined,
  orderNo: undefined as string | undefined,
  planId: undefined as string | number | undefined,
  grantDate: undefined as string[] | undefined
})

const getList = async () => {
  loading.value = true
  try {
    const params = {
      ...queryParams,
      planId: queryParams.planId ? Number(queryParams.planId) : undefined
    }
    const data = await CashbackGrantApi.getCashbackGrantPage(params)
    list.value = data.list
    total.value = data.total
  } finally {
    loading.value = false
  }
}
const handleQuery = () => {
  queryParams.pageNo = 1
  getList()
}
const resetQuery = () => {
  queryFormRef.value?.resetFields()
  handleQuery()
}

onMounted(getList)
</script>
